<template>
  <div class="min-h-screen bg-gray-50">
    <AuthCode
      :title="title"
      :subtitle="subtitle"
      :agreements="agreements"
      :onNext="handleSuccess"
      :onCancel="handleCancel"
    />
  </div>
</template>

<script>
import AuthCode from '@/components/AuthCode.vue';
import rpAPI from '../../shared/service/rpAPI.js';
import Globals from '../../shared/model/Globals.js';


export default {
  name: 'AuthorizationPage',
  components: {
    AuthCode,
  },
  data() {
    return {
      title: 'Potwierdź dane kontaktowe',
      subtitle: 'Podaj adres e-mail. Wyślemy na niego kod, aby potwierdzić Twoją tożsamość i dokończyć proces rejestracji.',
      redirectUrl: '/customer',
      cancelUrl: '',
      referrer: '',
      agreements: [],
    };
  },
  mounted() {


    this.initializeUrls();
    
    this.loadAgreements();
    
    // If already logged in, redirect to success URL
    if (rpAPI.isLoggedIn()) {
      this.redirect(this.redirectUrl);
    }
  },
  methods: {
    /**
     * Initialize redirect and cancel URLs from query parameters
     * Falls back to defaults if not provided
     */
    getStringQuery(name) {
      const value = this.$route?.query?.[name];
      return typeof value === 'string' ? value : null;
    },

    initializeUrls() {
      this.referrer = document.referrer;
      // Get redirect URL from query string, default to /customer
      this.redirectUrl = this.getStringQuery('redirect') || '/customer';
      
      // Get cancel URL from query string, fallback to referrer then Globals.APP_HOME_URL
      this.cancelUrl =
        this.getStringQuery('cancel') ||
        this.referrer ||
        Globals.APP_HOME_URL ||
        '/';
    },

    /**
     * Load agreements from API
     */
    async loadAgreements() {
      this.agreements = await rpAPI.getAgreements('signup');
    },

    /**
     * Handle successful registration
     * Redirects user to the redirect URL
     */
    handleSuccess() {
      console.log('Registration successful, redirecting to:', this.redirectUrl);
      this.redirect(this.redirectUrl);
    },

    /**
     * Handle registration cancellation
     * Redirects user to the cancel URL
     */
    handleCancel() {
      console.log('Registration cancelled, redirecting to:', this.cancelUrl);
      this.redirect(this.cancelUrl);
    },

    isSpaRoutePath(pathname) {
      console.log('Checking if SPA route path:', Globals.APP_ROUTES);
      const appRoutes = Object.values(Globals.APP_ROUTES || {});
      return appRoutes.some((route) => pathname === route || pathname.startsWith(route + '/'));
    },

    /**
     * Redirect to specified URL
     * @param {string} url - The URL to redirect to
     */
    redirect(url) {
      if (!url) return;

      const parsed = new URL(url, window.location.origin);
      const isSameOrigin = parsed.origin === window.location.origin;

      if (isSameOrigin && this.isSpaRoutePath(parsed.pathname)) {
      console.log('Redirecting to SPA route:', parsed.pathname);
      this.$router.replace(parsed.pathname);
      return;
      }

      console.log('Redirecting to external URL:', url);
      window.location.href = url;
    },
    },
};
</script>

<style scoped>
/* Optional: Add any page-specific styles here */
</style>